import { _ } from "../../../core/polyglot/polyglot.js";
import KeyFigurePreset from "./KeyFigurePreset.js";

/**
 * `CustomPreset` is a special preset used to hold a custom selection.
 */
export default class CustomPreset extends KeyFigurePreset {
	constructor(spec) {
		super(spec);
		this._id = "Custom";
		this._name = _("Custom");
		this._description = "";

		this.cssClass = "custom-option";
	}

	isCustom() {
		return true;
	}

	isSystemPreset() {
		return false;
	}
}
